import { useEffect, useState } from "react";
import axios from "axios";
import { Button, Col, Row, Form } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import PageLayout from "../../../layouts/PageLayout";
import DistributeDashboardRecord from "./DistributionDashboardRecord";

const DistributionDashboard = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [filterValues, setFilterValues] = useState({
    from_Date: "",
    to_Date: "",
  });
  const [error, setError] = useState("");

  const AuthToken = localStorage.getItem("AuthUser");
  axios.defaults.headers.common["Authorization"] = `Bearer ${AuthToken}`;

  const fetchData = async (params = {}) => {
    try {
      const res = await axios.get(
        process.env.REACT_APP_API_URL + "/distribution-dashboard",
        { params }
      );
      setData(res.data);
    } catch (error) {
      console.log(error, "distribution-dashboard");
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

const handleChange = (e) => {
  const { name, value } = e.target;
  const updated = { ...filterValues, [name]: value };
  setFilterValues(updated);

  const { from_Date, to_Date } = updated;

  if (!from_Date && !to_Date) {
    setError("");
  } else if (from_Date && !to_Date) {
    setError("Please select a To Date when From Date is chosen.");
  } else if (!from_Date && to_Date) {
    setError("Please select a From Date when To Date is chosen.");
  } else if (from_Date && to_Date && new Date(to_Date) < new Date(from_Date)) {
    setError("To Date cannot be earlier than From Date.");
  } else {
    setError("");
  }
};


  const handleSubmit = async () => {
    const { from_Date, to_Date } = filterValues;

    if (!from_Date && !to_Date) {
      setError("Please enter From Date and To Date.");
      return;
    }
    if (from_Date && !to_Date) {
      setError("Please select a To Date when From Date is chosen.");
      return;
    }
    if (!from_Date && to_Date) {
      setError("Please select a From Date when To Date is chosen.");
      return;
    }
    if (from_Date && to_Date && new Date(to_Date) < new Date(from_Date)) {
      setError("To Date cannot be earlier than From Date.");
      return;
    }

    setError("");
    const params = {};
    if (from_Date) params.from_Date = from_Date;
    if (to_Date) params.to_Date = to_Date;
    fetchData(params);
  };

  const handleClearFilter = () => {
    setFilterValues({ from_Date: "", to_Date: "" });
    setError("");
    fetchData();
  };

  return (
    <PageLayout>
      <Row>
        <Col xl={12}>
          <div className="mc-card">
            <div className="mc-breadcrumb">
              <h3 className="mc-breadcrumb-title">Data Distribution Dashboard</h3>
              <ul className="mc-breadcrumb-list">
                <li className="mc-breadcrumb-item">
                  <Link to="#" className="mc-breadcrumb-link" style={{ color: "#077834" }}>
                    home
                  </Link>
                </li>
                <li className="mc-breadcrumb-item">
                  <Link to="#" className="mc-breadcrumb-link" style={{ color: "#077834" }}>
                    Finances
                  </Link>
                </li>
                <li className="mc-breadcrumb-item">Dashboard</li>
              </ul>
            </div>
          </div>
        </Col>
      </Row>

      <Row>
        <Col xl={12}>
          <div className="mc-card p-3">
            <div className="mb-1">
              <h5 className="fw-bold mb-0">Filter by Date</h5>
            </div>

            <Row className="align-items-center g-3">
              <Col md="auto">
                <Form.Label className="mb-0">From:</Form.Label>
              </Col>
              <Col md={3}>
                <Form.Control
                  name="from_Date"
                  type="date"
                  value={filterValues.from_Date}
                  onChange={handleChange}
                />
              </Col>

              <Col md="auto">
                <Form.Label className="mb-0">To:</Form.Label>
              </Col>
              <Col md={3}>
                <Form.Control
                  name="to_Date"
                  type="date"
                  value={filterValues.to_Date}
                  onChange={handleChange}
                />
              </Col>

              <Col md="2">
                <Button
                  onClick={handleSubmit}
                  style={{
                    backgroundColor: "#077834",
                    fontWeight: "bold",
                    fontSize: "12px",
                  }}
                >
                  Apply Filter
                </Button>
              </Col>

              <Col md="2">
                <Button
                  onClick={handleClearFilter}
                  className="bg-secondary"
                  style={{ fontWeight: "bold", fontSize: "12px" }}
                >
                  Clear Filter
                </Button>
              </Col>
            </Row>

            {error && (
              <div className="text-danger mt-2" style={{ fontSize: "13px" }}>
                {error}
              </div>
            )}
          </div>
        </Col>
      </Row>

      <Row>
        <DistributeDashboardRecord data={data ? data : ""} />
      </Row>
    </PageLayout>
  );
};

export default DistributionDashboard;
